<template>
  <section class="section-padding" id="about">
    <div class="container-fluid container-lg">
      <div class="row justify-content-center align-items-center">
        <div class="about-header mb-5">
          <h2>About Us</h2>
        </div>
        <carousel :per-page="1" :mouse-drag="true" :autoplay="true" :autoplayHoverPause="false" :autoplayTimeout="7000" paginationActiveColor="#ff9900" :loop="true">

          <slide>
            <div class="col-12 col-md-10 mx-auto text-center">
              <div class="about-text">
                <img src="../assets/dacodewhite.svg"  height="40" alt="Dacode white Logo">
                <div class="mt-4">
                  <p>We are a team of collaborative experienced web developers with the sole aim of helping individual and business in achieving their dreamed innovations.We also train both computer and non-computer literates how to build secure and scalable web applications personally.</p>
                </div>
              </div>
            </div>
          </slide>

          <slide>
            <div class="col-12 col-md-10 mx-auto text-center">
              <div class="about-text">
                <img src="../assets/dacodewhite.svg"  height="40" alt="Dacode white Logo">
                <div class="mt-4">
                  <p>Dacode is an innovative and top-notch IT expert in Nigeria. we are devoted to building secure and scalable softwares for both individual and business.</p>
                </div>
              </div>
            </div>
          </slide>

          <slide>
            <div class="col-12 col-md-10 mx-auto text-center">
              <div class="about-text">
                <img src="../assets/dacodewhite.svg"  height="40" alt="Dacode white Logo">
                <div class="mt-4">
                  <p>We help both individual and business in achieving a strong online presence by analysing and examining your business idea or structure so we can build a befiting web application for your brand. </p>
                </div>
              </div>
            </div>
          </slide>

         

      </carousel>

        

      </div>
    </div>
  </section>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
  components: {
    Carousel,
    Slide
  }
}
</script>

<style>
.section-padding {
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}

#about {
  background-image: url("../assets/dacodeaboutbg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
}

#about::before {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: var(--dacode-primary-color) !important;
  opacity: .9;
}

#about .about-header, .about-text {
  position: relative;
  z-index: 10;
}

#about h2{
  color: var(--dacode-secondary-color);
  font-size: 1.3rem;
  text-align: center;
}

#about p {
  font-size: 1.15rem;
  color: var(--dacode-white-color);
  letter-spacing: 2px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.92);
}


</style>

